export const RouteNames = {
  Marketing: "/",
  Templates: "/app/templates",
  Home: "/app",
  SignIn: "/sign_up",
  Journal: "/app/:board/journal/:date",
  Edit: "/app/edit",
};
